/**
 * Cart Services Upsell (Yeppon) — "seconda occasione"
 * Per ogni prodotto in carrello SENZA servizi (placeholder [data-svc-upsell]),
 * chiama il proxy della scheda (product_shipping_info_box). Se il prodotto ha
 * servizi (elettrodomestico), mostra i bottoni Aggiungi coi prezzi esatti.
 * Il click aggiunge la variante servizio con _svc_price (prezzata dalla Function).
 */
(function () {
  'use strict';

  var SVC_STORE = window.__svcVariants || {};
  var SERVICE_VARIANTS = SVC_STORE.INST ? SVC_STORE : {
    INST: '65719443194205',
    RAEE: '65719443226973',
    GPO: '65719443259741',
    INC: '65773405274461',
    KC: '65783243342173'
  };
  // i servizi presuppongono la consegna al piano: se manca, la riga-marcatore
  // ALP (0,00 - "Inclusa nella spedizione") viene aggiunta insieme al servizio
  var ALP_MARKER_VARIANT = SVC_STORE.ALP || '65719443161437';
  // zona scelta in scheda (fase 2 CAP): riusata qui per la nota trasparenza costi
  function getCap() {
    try {
      var z = localStorage.getItem('yp_svc_cap') || '';
      return /^\d{5}$/.test(z) && z !== '00000' ? z : '';
    } catch (e) { return ''; }
  }
  var ALP_SHIPPING_ID = 39;
  function codeForName(name) {
    var n = (name || '').toLowerCase();
    // "colonna" PRIMA di "installazione": "Installazione a colonna" contiene entrambe
    if (n.indexOf('colonna') !== -1) return 'KC';
    if (n.indexOf('installazione') !== -1) return 'INST';
    if (n.indexOf('ritiro') !== -1) return 'RAEE';
    if (n.indexOf('inversione') !== -1) return 'GPO';
    if (n.indexOf('incasso') !== -1) return 'INC';
    return null;
  }
  function parseEuro(text) {
    if (!text) return null;
    if (/gratis/i.test(text)) return 0;
    var m = text.replace(/\s/g, '').match(/([\d.]*\d(?:,\d{1,2})?)/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  function fmtEuro(n) { return n === 0 ? 'Gratis' : n.toFixed(2).replace('.', ',') + ' €'; }
  function clean(t) { return (t || '').replace(/\s+/g, ' ').replace(/\*+/g, '').trim(); }

  function parseAddons(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var addons = [];
    // prezzo consegna al piano (primo h5): serve per la nota trasparenza costi
    var alpPrice = null;
    var h5 = doc.querySelector('h5');
    if (h5 && /al piano/i.test(h5.textContent || '')) {
      var sp = h5.querySelectorAll('span');
      alpPrice = parseEuro(sp[1] ? sp[1].textContent : '');
    }
    parseAddons.lastAlpPrice = alpPrice;
    var lis = doc.querySelectorAll('ul li');
    Array.prototype.forEach.call(lis, function (li) {
      var raw = li.textContent || '';
      var price = null;
      var pm = raw.match(/\(\s*\+?\s*€\s*[\d.,]+\s*\)/);
      if (pm) price = parseEuro(pm[0]);
      else if (/\(\s*gratis\s*\)/i.test(raw)) price = 0;
      if (price === null) return;
      var base = raw.replace(/\(\s*\+?\s*€\s*[\d.,]+\s*\)/i, '').replace(/\(\s*gratis\s*\)/i, '');
      var name = clean(base.split('(')[0]);
      var code = codeForName(name);
      if (code && SERVICE_VARIANTS[code]) addons.push({ name: name, price: price, code: code });
    });
    return addons;
  }

  function build(row, addons, parentGid, alpPrice, hasAlp) {
    var box = row.querySelector('[data-svc-upsell-box]');
    if (!box) return;
    var head = document.createElement('div');
    head.style.cssText = 'font-size:1.25rem;font-weight:600;color:#0a5c2d;margin-bottom:0.6rem;';
    head.textContent = 'Vuoi aggiungere un servizio?';
    box.appendChild(head);
    var wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:0.6rem;';
    addons.forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.style.cssText = 'height:3.2rem;padding:0 1.2rem;background:#fff;border:0.1rem solid #bfe0cc;color:#0a5c2d;border-radius:0.6rem;font-size:1.2rem;font-weight:600;cursor:pointer;';
      b.textContent = a.name + ' · ' + (a.price > 0 ? '+ ' : '') + fmtEuro(a.price);
      b.addEventListener('click', function () {
        b.disabled = true;
        b.textContent = 'Aggiungo…';
        // quantita' del padre: il servizio nasce gia' allineato (niente doppio reload della sync)
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var qty = 0, hasAlp = false;
            cart.items.forEach(function (i) {
              var isSvc = i.properties && i.properties._parent;
              if (!isSvc && ('gid://shopify/Product/' + i.product_id) === parentGid) qty += i.quantity;
              if (isSvc && i.properties._parent === parentGid && i.properties._svc_code === 'ALP') hasAlp = true;
            });
            if (qty < 1) qty = 1;
            var items = [{ id: SERVICE_VARIANTS[a.code], quantity: qty, properties: { _svc_price: a.price.toFixed(2), _svc_code: a.code, _svc_label: a.name, _parent: parentGid } }];
            if (!hasAlp) {
              items.unshift({ id: ALP_MARKER_VARIANT, quantity: qty, properties: { _svc_price: '0.00', _svc_code: 'ALP', _svc_label: 'Consegna al piano e disimballo', _parent: parentGid } });
            }
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function () { window.location.reload(); })
          .catch(function () { b.disabled = false; b.textContent = a.name; });
      });
      wrap.appendChild(b);
    });
    box.appendChild(wrap);
    if (!hasAlp && alpPrice != null && alpPrice > 0) {
      var note = document.createElement('div');
      note.style.cssText = 'margin-top:0.7rem;font-size:1.1rem;line-height:1.45;color:#0a5c2d;';
      var cap = getCap();
      note.textContent = 'I servizi includono la Consegna al piano: al checkout la spedizione sarà "Consegna con servizio al piano" (' +
        fmtEuro(alpPrice) + (cap ? ' per il CAP ' + cap : ' indicativi') + ').';
      box.appendChild(note);
    }
    row.removeAttribute('hidden');
  }

  function init() {
    var rows = document.querySelectorAll('[data-svc-upsell]');
    if (!rows.length) return;
    // servizi gia' in carrello per prodotto padre: quelli non vanno riproposti
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = {};
        cart.items.forEach(function (i) {
          var p = i.properties && i.properties._parent;
          var code = i.properties && i.properties._svc_code;
          if (p && code) have[p + '|' + code] = true;
        });
        Array.prototype.forEach.call(rows, function (row) {
          var apiUrl = (row.getAttribute('data-api-url') || '').replace(/\/$/, '');
          var parentGid = row.getAttribute('data-parent-gid');
          if (!apiUrl || !parentGid) return;
          var cap = getCap();
          var endpoint = apiUrl + '?type=' + encodeURIComponent('product_shipping_info_box') +
            '&product_id=' + encodeURIComponent(parentGid) + '&logged_in_customer_id=' +
            (cap ? '&zipCode=' + encodeURIComponent(cap) : '');
          fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (!d || !d.html) return;
              var addons = parseAddons(d.html).filter(function (a) {
                if (have[parentGid + '|' + a.code]) return false;
                // KC solo se l'installazione classica e' gia' in carrello per questo prodotto
                if (a.code === 'KC' && !have[parentGid + '|INST']) return false;
                return true;
              });
              // prezzo al piano: campi strutturati (id 39) con fallback al parsing html
              var alpPrice = parseAddons.lastAlpPrice;
              if (d.shippingList && d.shippingList.length) {
                d.shippingList.forEach(function (o) { if (o.id === 39) alpPrice = o.price; });
              }
              if (addons.length) build(row, addons, parentGid, alpPrice, !!have[parentGid + '|ALP']);
            })
            .catch(function () {});
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
